import Events from './Events';

export default new Events();



// WEBPACK FOOTER //
// ./src/Events/index.js